import React, { useContext } from 'react';

import SalesOrdersContext from '@totem/components/salesOrders/list/SalesOrdersContext';
import SalesOrdersFilters from '@totem/components/salesOrders/list/SalesOrdersFilters';
import SalesOrdersTable from '@totem/components/salesOrders/list/SalesOrdersTable';

export const SalesOrdersExtra = () => {
  const { totalRecords, loading } = useContext(SalesOrdersContext);
  if (loading) {
    return null;
  }
  return <span>{totalRecords} lines</span>;
};

const SalesOrdersLayout = () => (
  <>
    <SalesOrdersFilters />
    <SalesOrdersTable />
  </>
);

export default SalesOrdersLayout;
